/**
 * Bind action link in dropdown to close all SMDropdown on click.
 */
export function initDropdownActionLink(actionLink) {
  if (actionLink.dataset.dropdownCloseBound === 'true') {
    return;
  }

  actionLink.dataset.dropdownCloseBound = 'true';
  actionLink.addEventListener('click', () => {
    if (typeof SMDropdown !== 'undefined') {
      SMDropdown.closeAll();
    }
  });
}
